window._ = require('lodash');


try {
    global.Popper = require('popper.js').default;
    global.$ = global.jQuery = require('jquery');


    require('bootstrap');
    require('bootstrap-select/dist/js/bootstrap-select');
    require('datatables.net-bs4');

    require('jquery.are-you-sure');
    $(document).ready(function(){
        const $forms = $('form:not(.without-confirm-exit)');
        $forms.areYouSure();
    });


} catch (e) {
    console.error(e)
}
